// 数据可视化api 2020-07-02
import $http from '../http';
let complaintPath = '/v2/complain/api/';

// 可视化接口
// export const queryTrend = data => {
//   return $http({
//       url: complaintPath + 'dataVisualization/display',
//       data,
//       method: 'POST'
//   });
// };

// 获取省市区
export const getAllRegion = (data) => {
  return $http({
    url: complaintPath + 'publicCondition/getAllRegion',
    data,
    method: 'POST'
  });
};

// 可视化接口 老接口应该调用不通了，换baseurl 了
export const queryTrend = (data) => {
  return $http({
    url: complaintPath + 'qywx/display/dataVisualization',
    data,
    method: 'POST'
  });
};

// 可视化接口 2026 年 3 月 26 日 17:30 废弃了
export const getAllPhoneAttribution = (data) => {
  return $http({
    url: complaintPath + 'getAllPhoneAttribution',
    data,
    method: 'POST'
  });
};

/**
 * 处置区域分析
 * @wiki: https://www.tapd.cn/67427372/markdown_wikis/show/#1167427372001007992
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.channel
 * @param {string} params.startDate
 * @param {string} params.endDate
 * @param {string} params.rule
 * @returns {Array}
 */
export const regionCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/region/count',
    params,
    method: 'get'
  });
};

/**
 * 处置满意度
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.channel
 * @param {string} params.startDate
 * @param {string} params.endDate
 * @param {string} params.rule
 * @param {int} params.evaluationType
 * @returns {Array}
 */
export const evaluateCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/evaluate/count',
    params,
    method: 'get'
  });
};
/**
 * 平均办结时长
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.channel
 * @param {string} params.startDate
 * @param {string} params.endDate
 * @param {string} params.rule
 * @param {int} params.assess
 * @returns {Array}
 */
export const completeTimeCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/completeTime/count',
    params,
    method: 'get'
  });
};

/**
 * 24小时办结率
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.channel
 * @param {string} params.startDate
 * @param {string} params.endDate
 * @param {string} params.rule
 * @param {int} params.assess
 * @returns {Array}
 */
export const complete24Rate = (params) => {
  return $http({
    url: complaintPath + 'analysis/complete24Rate/count',
    params,
    method: 'get'
  });
};

/**
 * 平均响应时长
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.channel
 * @param {string} params.startDate
 * @param {string} params.endDate
 * @param {string} params.rule
 * @param {int} params.assess
 * @returns {Array}
 */
export const firstPointResponseCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/firstPoint/response/count',
    params,
    method: 'get'
  });
};

/**
 * 第一落点分布
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.channel
 * @param {string} params.startDate
 * @param {string} params.endDate
 * @param {string} params.rule
 * @param {int} params.assess
 * @returns {Array}
 */
export const firstPointCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/firstPoint/count',
    params,
    method: 'get'
  });
};

//投诉渠道 字典
export const getComplainChannel = (data) => {
  return $http({
    url: complaintPath + 'complaint/publicCondition/getComplainChannel',
    method: 'post',
    data
  });
};

// 统计规则
export const getAnalysisRule = () => {
  return $http({
    url: complaintPath + 'dict/analysis/rule',
    method: 'get'
  });
};

// 游客分析投诉渠道
export const getChannelCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/channel/count',
    params,
    method: 'get'
  });
};

//analysis/tripMode/count
export const getTripModeCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/tripMode/count',
    params,
    method: 'get'
  });
};
//analysis/origin/count
export const getOriginCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/origin/count',
    params,
    method: 'get'
  });
};

// 投诉件概况
export const getOverviewCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/overview/count',
    params,
    method: 'get'
  });
};

//投诉件分类
export const getClassifyCount = (params) => {
  return $http({
    url: complaintPath + 'analysis/classify/count',
    params,
    method: 'get'
  });
};

//投诉件发起量走势
export const getComplaintTrend = (params) => {
  return $http({
    url: complaintPath + 'analysis/complaint/trend',
    params,
    method: 'get'
  });
};

// 获取账号当前所属行政区域的所有下级区域（包含本级）
export const getAllRegionIncludeSelf = () => {
  return $http({
    url: complaintPath + 'complaint/publicCondition/getAllRegionIncludeSelf',
    method: 'get'
  });
};

export default {
  queryTrend,
  getAllRegion,
  getAllPhoneAttribution,
  regionCount,
  evaluateCount,
  completeTimeCount,
  complete24Rate,
  firstPointResponseCount,
  firstPointCount,
  getComplainChannel,
  getAnalysisRule,
  getChannelCount,
  getTripModeCount,
  getOriginCount,
  getOverviewCount,
  getClassifyCount,
  getComplaintTrend,
  getAllRegionIncludeSelf
};
